import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

//the built-in angular email validator has a quirk where it marks the control invalid when empty
export function OptionalEmail(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  } else {
    return Validators.email(control);
  }
}
